import React, { useState } from "react";
import { Paintbrush } from "lucide-react";
import { cn } from "../../lib/utils";
import Card from "../ui/Card";

const BackgroundPanel = ({ previewSettings, onSettingsChange }) => {
  const handleChange = (key, value) => {
    onSettingsChange({ [key]: value });
  };

  const solidColors = [
    "#000000", // Black
    "#FFFFFF", // White
    "#1E40AF", // Blue
    "#059669", // Green
    "#7C3AED", // Purple
    "#DC2626", // Red
    "#EA580C", // Orange
    "#F59E0B", // Amber
  ];

  const presetGradients = [
    { name: "Purple Blue", value: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" },
    { name: "Pink Orange", value: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" },
    { name: "Green Blue", value: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)" },
    { name: "Sunset", value: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)" },
    { name: "Ocean", value: "linear-gradient(135deg, #2E3192 0%, #1BFFFF 100%)" },
    { name: "Purple Pink", value: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)" },
    { name: "Dark Blue", value: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)" },
    { name: "Violet", value: "linear-gradient(135deg, #8360c3 0%, #2ebf91 100%)" },
  ];

  const handleSolidColorClick = (color) => {
    handleChange("backgroundType", "solid");
    handleChange("wrapperBackgroundColor", color);
  };

  const handleGradientClick = (gradient) => {
    handleChange("backgroundType", "gradient");
    handleChange("gradientBackground", gradient);
  };

  const handleCustomColorChange = (color) => {
    handleChange("backgroundType", "solid");
    handleChange("wrapperBackgroundColor", color);
  };

  return (
    <Card className="p-6 space-y-6">
      <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
        <Paintbrush className="w-5 h-5" />
        Background
      </h3>

      {/* Solid Colors */}
      <div>
        <label className="text-sm font-medium text-zinc-300 mb-3 block">
          Solid Colors
        </label>
        <div className="grid grid-cols-4 gap-2">
          {solidColors.map((color) => (
            <button
              key={color}
              onClick={() => handleSolidColorClick(color)}
              className={cn(
                "w-full aspect-square rounded-lg border-2 transition-all hover:scale-105",
                previewSettings.backgroundType === "solid" &&
                previewSettings.wrapperBackgroundColor === color
                  ? "border-blue-500 ring-2 ring-blue-500/50"
                  : "border-zinc-700 hover:border-zinc-600"
              )}
              style={{ backgroundColor: color }}
              title={color}
            />
          ))}
          {/* Custom Color Picker */}
          <div className="relative">
            <input
              type="color"
              value={
                previewSettings.backgroundType === "solid"
                  ? previewSettings.wrapperBackgroundColor || "#000000"
                  : "#000000"
              }
              onChange={(e) => handleCustomColorChange(e.target.value)}
              className="w-full aspect-square rounded-lg border-2 border-zinc-700 cursor-pointer hover:border-zinc-600 transition-all"
              title="Custom Color"
            />
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <span className="text-xs text-white drop-shadow-lg">+</span>
            </div>
          </div>
        </div>
      </div>

      {/* Gradient Colors */}
      <div>
        <label className="text-sm font-medium text-zinc-300 mb-3 block">
          Gradient Colors
        </label>
        <div className="grid grid-cols-4 gap-2">
          {presetGradients.map((gradient, index) => (
            <button
              key={index}
              onClick={() => handleGradientClick(gradient.value)}
              className={cn(
                "w-full aspect-square rounded-lg border-2 transition-all hover:scale-105",
                previewSettings.backgroundType === "gradient" &&
                previewSettings.gradientBackground === gradient.value
                  ? "border-blue-500 ring-2 ring-blue-500/50"
                  : "border-zinc-700 hover:border-zinc-600"
              )}
              style={{ background: gradient.value }}
              title={gradient.name}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};

export default BackgroundPanel;

